import styled from 'styled-components';

export const LoadingContainer = styled.div`
  min-height: 60vh;
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StateIcon = styled.i`
  font-size: 100px;
`;
